import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { imgProsesBaseURL,prosesBaseURL } from '../../Api';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

function ProsesDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {};
  const [selectedImage, setSelectedImage] = useState(null);
  if (!item) {
    return <p>No data available</p>;
  }

  const imagePaths = item.gambar ? item.gambar.split(',') : [];

  const handleOpenImage = (src) => {
    setSelectedImage(src);
  };

  const handleCloseImage = () => {
    setSelectedImage(null);
  };

  const handleDownloadAllImages = async () => {
    const zip = new JSZip();
    const folder = zip.folder('proses-pengerjaan');
    const allPaths = [...imagePaths];

    for (let i = 0; i < allPaths.length; i++) {
      const path = allPaths[i];
      const originalURL = `${imgProsesBaseURL}${path}`;
      const proxyURL = `https://master.jasaindonesiaperdana.com/api/download-image?url=${encodeURIComponent(
        originalURL
      )}`;
      const fileExt = originalURL.substring(originalURL.lastIndexOf('.'));
      const fileName = `image_${i + 1}${fileExt}`;

      try {
        const response = await fetch(proxyURL);
        const blob = await response.blob();
        folder.file(fileName, blob);
      } catch (err) {
        console.error(`Gagal unduh: ${originalURL}`, err);
      }
    }

    zip.generateAsync({ type: 'blob' }).then((content) => {
      saveAs(content, 'semua-gambar-proses.zip');
    });
  };
  const handleDocumentClick = (document) => {
    if (typeof document === 'undefined') return;

    const fileUrl = `${prosesBaseURL}${document.nama_dokumen}`;
    if (document.nama_dokumen.endsWith('.pdf')) {
      navigate('/pdf-viewer', { state: { file: fileUrl } });
    } else {
      const link = window.document.createElement('a');
      link.href = fileUrl;
      link.download = document.nama_dokumen;
      link.click();
    }
  };
  return (
    <div className="detail-page">
      <div className="subheading_wrap">
        <div>
          <h3 className="subheading_title">{item.nama_instalasi}</h3>
        </div>
      </div>
      <div className="detail-content">
        <div className="item-detail">
          <div className="item-detail-left">Tanggal Pengiriman</div>
          <div className="item-detail-right">{item.tgl_pengiriman}</div>
        </div>
        <div className="item-detail">
          <div className="item-detail-left">Nomor Surat Jalan</div>
          <div className="item-detail-right">{item.no_surat_jln}</div>
        </div>
        <div className="item-detail">
          <div className="item-detail-left">Nomor Kwitansi</div>
          <div className="item-detail-right">{item.no_kwitansi}</div>
        </div>
        {imagePaths.length > 0 && (
          <>
            <div
              className="item-detail-left"
              style={{ width: '100%', textAlign: 'center', marginTop: '20px' }}
            >
              Gambar
            </div>
            <div className="item-detail">
              {imagePaths.map((path, index) => (
                <div key={index} className="bukti_detail">
                  <img
                    src={`${imgProsesBaseURL}${path}`}
                    alt={`Bukti Pengerjaan ${index + 1}`}
                    onClick={() =>
                      handleOpenImage(`${imgProsesBaseURL}${path}`)
                    }
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              ))}
            </div>
          </>
        )}
        <div className="btn-request">
          <button
            className="download-images-btn"
            onClick={handleDownloadAllImages}
            style={{ marginBottom: '10px', width: '100%' }}
          >
            Download Semua Gambar
          </button>
        </div>
        <div className="item-detail dokumen">
          <h3 className="subheading_title">Dokumen</h3>         
        </div>
        {item.details && item.details.length > 0 ? (
            <div className="item-list">
              {item.details.map((doc, index) => (
                <div
                  key={doc.id}
                  className="item"
                  style={{ marginBottom: '10px' }}
                >
                  <div className="item-date">
                          <span className="item-day">{doc.tgl_dokumen.split('-')[0]}</span>
                          <span className="item-month">{doc.tgl_dokumen.split('-')[1]}</span>
                          <span className="item-year">{doc.tgl_dokumen.split('-')[2]}</span>
                        </div>
                  
                        <div className="item-content">
                          <p className="item-description">{item.perusahaan.nama_perusahaan}</p>
                          <h3
                            className="item-title"
                            onClick={() => handleDocumentClick(doc)}
                            style={{ cursor: 'pointer' }}
                          >
                            {doc.nama_dokumen}
                          </h3>
                          <p className="item-description">{doc.size}</p>
                        </div>
                </div>
              ))}
            </div>
          ) : (
            <p>Tidak ada dokumen tersedia.</p>
          )}
      </div>
      {selectedImage && (
        <div className="onlarge-image" onClick={handleCloseImage}>
          <img
            src={selectedImage}
            alt="Preview"
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              boxShadow: '0 0 10px rgba(255,255,255,0.6)',
              borderRadius: '10px',
            }}
          />
          <button className="close-image" onClick={handleCloseImage}>
            &times;
          </button>
        </div>
      )}
    </div>
  );
}

export default ProsesDetail;
